import React from "react";

export type SelectSize = "sm" | "md" | "lg";

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface SelectProps {
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  size?: SelectSize;
  placeholder?: string;
  disabled?: boolean;
  name?: string;
  ariaLabel?: string;
  className?: string;
  fullWidth?: boolean;
  invalid?: boolean;
  autoFocus?: boolean;
}

const HEIGHT: Record<SelectSize, string> = {
  sm: "var(--control-height-sm)",
  md: "var(--control-height-md)",
  lg: "var(--control-height-lg)",
};
const PADDING_X: Record<SelectSize, string> = {
  sm: "var(--control-padding-x-sm)",
  md: "var(--control-padding-x-md)",
  lg: "var(--control-padding-x-lg)",
};

export const Select: React.FC<SelectProps> = ({
  value,
  onChange,
  options,
  size = "md",
  placeholder,
  disabled,
  name,
  ariaLabel,
  className,
  fullWidth,
  invalid,
  autoFocus,
}) => (
  <select
    name={name}
    aria-label={ariaLabel}
    aria-invalid={invalid || undefined}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    disabled={disabled}
    className={className}
    autoFocus={autoFocus}
    style={{
      height: HEIGHT[size],
      paddingInline: PADDING_X[size],
      fontFamily: "var(--font-sans)",
      fontSize: "var(--font-size)",
      color: "var(--color-fg)",
      background: "var(--color-bg-subtle)",
      border: `var(--size-border-hairline) solid ${invalid ? "var(--color-error)" : "var(--color-border)"}`,
      borderRadius: "var(--radius-app)",
      cursor: disabled ? "not-allowed" : "pointer",
      width: fullWidth ? "100%" : undefined,
    }}
  >
    {placeholder && (
      <option value="" disabled>
        {placeholder}
      </option>
    )}
    {options.map((opt) => (
      <option key={opt.value} value={opt.value} disabled={opt.disabled}>
        {opt.label}
      </option>
    ))}
  </select>
);
